// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Word: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16">
            <path
                fill="currentColor"
                d="M7,4 L7,0 L1.5,0 C0.671562672,0 0,0.671562195 0,1.5 L0,14.5 C0,15.328125 0.671562672,16 1.5,16 L10.5,16 C11.3284378,16 12,15.3284378 12,14.5 L12,5 L8.02812481,5 C7.4468751,5 7,4.55312538 7,4 Z M8.796875,7.5 L9.52718735,7.5 C9.76834393,7.5 9.94687462,7.72437477 9.89249992,7.9593749 L8.56562519,13.7093754 C8.52812481,13.8781252 8.375,14 8.203125,14 L7.28875017,14 C7.11918783,14 6.97062492,13.886219 6.92656279,13.7224064 L6,10.2843752 L5.07468748,13.6937504 C5.00312519,13.8874998 4.8812499,14 4.7125001,14 L3.796875,14 C3.62225008,14 3.47062492,13.879406 3.43156242,13.709219 L2.10468721,7.95921898 C2.05187464,7.7249999 2.23031235,7.5 2.47125006,7.5 L3.20156288,7.5 C3.3761878,7.5 3.52781296,7.62059355 3.56687546,7.79065609 L4.30625057,11 L5.17500067,7.77812481 C5.21875048,7.61250019 5.36875057,7.5 5.53750038,7.5 L6.4628129,7.5 C6.63237524,7.5 6.78093767,7.61378145 6.82500029,7.77759361 L7.69375038,11 L8.43437529,7.7906251 C8.47187567,7.62187481 8.59687567,7.5 8.79687548,7.5 L8.796875,7.5 Z M8.00000048,0 L8.00000048,4 L12.0000005,4 L8.00000048,0 Z"
            />
        </svg>
    );
};

export default React.memo(Word);
